import { useLocalStorage } from '@airship-platform/airship-patterns';
import { requestPersistentStorage } from './utils/storageEstimate';
import { OPTED_IN_KEY } from './utils/storageKeys';

const PRICEBOOK_SYNC_KEY = 'offline-sync-pricebook';
const MEMBERSHIP_SYNC_KEY = 'offline-sync-membership';

export const useOfflineOptIn = () => {
  const [rawOptedIn, setRawOptedIn] = useLocalStorage(OPTED_IN_KEY);
  const [lastPricebookSync] = useLocalStorage(PRICEBOOK_SYNC_KEY);
  const [lastMembershipSync] = useLocalStorage(MEMBERSHIP_SYNC_KEY);

  const canOptIn = !!lastPricebookSync && !!lastMembershipSync;
  const isOptedIn = rawOptedIn === 'true' && canOptIn;

  const setOptedIn = (value: boolean) => {
    const optingIn = value && canOptIn;

    if (optingIn) {
      void requestPersistentStorage();
    }

    setRawOptedIn(optingIn ? 'true' : undefined);
  };

  return { isOptedIn, setOptedIn, canOptIn };
};
